export const optionCorText = [
  { value: 0, label: 'Não informado' },
  { value: 1, label: 'Black' },
  { value: 2, label: 'White' },
];
